import React, {Component} from "react";
import {InvoiceService} from "../../../../service/admin/invoice/InvoiceService";
import EditInstitutionInvoiceView from "./EditInstitutionInvoiceView";
import {
    EDIT_PARAMETERS_ROUTE,
    UPDATE_ADDRESS_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import ContextMenu from "../../../../components/contextMenu";
import ConfirmationMessage from "../../../../components/confirmationMessage";
import {ADDRESS_BY_ACCOUNT} from "../../../../utils/constants/Constants";

export default class EditInstitutionInvoiceContainer extends Component {
    constructor(props) {
        super(props);

        this.invoiceService = new InvoiceService();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        }
        this.loading = this.loading.bind(this);
        this.returnEditParameters = this.returnEditParameters.bind(this);
        this.redirectUpdateAddress = this.redirectUpdateAddress.bind(this);
        this.getInstitutionAddresses = this.getInstitutionAddresses.bind(this);
        this.deleteAddress = this.deleteAddress.bind(this);
        this.saveAllAddress = this.saveAllAddress.bind(this);
        this.institutionInvoiceActionTemplate = this.institutionInvoiceActionTemplate.bind(this);
        this.onChangeRadio = this.onChangeRadio.bind(this);
        this.handleSelectedRow = this.handleSelectedRow.bind(this);

        this.state = {
            isLoading: true,
            institutionAddresses: [],
            institutionData: this.props.location.state.selectedInstitution,
            disabledAddButton: false,
        };
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
        if (!this.props.location.state.institutionAddresses){
            this.getInstitutionAddresses();
        }else{
            this.setState({
                institutionAddresses: this.props.location.state.institutionAddresses,
            });
            this.loading(false);
        }
    }

    returnEditParameters(message) {
        this.props.history.push({
            pathname: EDIT_PARAMETERS_ROUTE,
            message: message,
        });
    }

    redirectUpdateAddress(addressDataAux, isNewAddress) {
        this.props.history.push({
            pathname: UPDATE_ADDRESS_ROUTE,
            state: {
                institutionData: this.state.institutionData,
                institutionAddresses: this.state.institutionAddresses,
                addressData: addressDataAux,
                newAddress: isNewAddress,
            },
        });
    }

    getInstitutionAddresses() {
        this.loading(true);
        this.invoiceService.getAddressesInstitution(
            this.state.institutionData.IdInstitucion
        ).then(response => {
            this.setState({
                institutionAddresses: response.payload,
            });
            this.loading(false);
        });
    }

    institutionInvoiceActionTemplate(rowData, column) {
        let optionsMenu = [
            {label: "Editar", action: () => this.redirectUpdateAddress(rowData,false)},
            {label: "Eliminar", action: this.confirmationRef.openConfirmationMessage},
        ];
        return (
            <ContextMenu menuOptions = {optionsMenu}/>
        );
    }

    deleteAddress(){
        let addressSelected = this.state.addressSelected;
        this.setState({
            institutionAddresses: this.state.institutionAddresses
                .filter((val) => val !== addressSelected)
        });
    }

    saveAllAddress(){
        if(this.state.institutionAddresses.length === 0){
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'No ha agregado alguna dirección.'
            });
        }else if(this.state.institutionData['IdTipo'] === ADDRESS_BY_ACCOUNT){
            if(this.state.institutionAddresses.length === this.props.location.state.nAccounts){
                this.returnEditParameters({
                    severity: 'success',
                    summary: 'Éxito',
                    detail: 'Se actualizado correctamente su solicitud.',
                });
            }else{
                this.growl.show({
                    severity: 'error', summary: 'Error.',
                    detail: 'No ha agregado todas las direcciones.'
                });
            }
        }else{
            this.returnEditParameters({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Se actualizado correctamente su solicitud.',
            });
        }
    }

    handleSelectedRow (event){
        this.setState({
                addressSelected: event.value,
            });
    }

    onChangeRadio(event) {
        let institutionDataAux = this.state.institutionData;
        institutionDataAux['IdTipo'] = event.value;
        this.setState({
            institutionData: institutionDataAux,
            institutionAddresses: [],
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        let {isLoading, institutionAddresses, institutionData, disabledAddButton} = this.state;
        this.confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                            invisible={true}
                                            legend="¿Desea eliminar la dirección seleccionada?"
                                            action={this.deleteAddress}/>;
        return <EditInstitutionInvoiceView
            isLoading={isLoading}
            institutionData={institutionData}
            institutionAddresses={institutionAddresses}
            disabledAddButton={disabledAddButton}
            messagesGrowl={messagesGrowl}
            confirmationMsg={this.confMsg}
            returnEditParameters={this.returnEditParameters}
            institutionInvoiceActionTemplate={this.institutionInvoiceActionTemplate}
            onChangeRadio={this.onChangeRadio}
            handleSelectedRow={this.handleSelectedRow}
            redirectUpdateAddress={this.redirectUpdateAddress}
            saveAllAddress = {this.saveAllAddress}
            loading={this.loading}
        />
    }
};
